module.exports = __webpack_public_path__ + "static/media/alcohol-and-addictions.7f61adad.png";